// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-icon svg{height:30px !important;width:30px !important}`, "",{"version":3,"sources":["webpack://./src/components/BlockEditor/Blocks/FileBlock/_FileBrowser.scss"],"names":[],"mappings":"AACC,eACC,sBAAA,CACA,qBAAA","sourcesContent":[".file-icon {\n\tsvg {\n\t\theight: 30px !important;\n\t\twidth: 30px !important;\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
